module.exports = __webpack_public_path__ + "img/50.207c60e5.png";